import { Dispatch } from 'redux'
import { SET_BOOKING_ATTRIBUTION, UPDATE_GROUPED_FILTERS } from './constants'

export const updateGroupedFilters = (
  dispatch: Dispatch,
  payload: GroupedProviderFilter
): void => {
  dispatch({
    type: UPDATE_GROUPED_FILTERS,
    payload,
  })
}

export const setBookingAttribution = (
  payload: BookingAttribution
): ReducerActions<BookingAttribution> => {
  return {
    type: SET_BOOKING_ATTRIBUTION,
    payload,
  }
}
